import React from 'react';

/**
 * Heading block at the top of a step: a question-style title plus an optional
 * supporting line. Replaces the old centered header title / "Doação segura" tag.
 *
 * @param {{ title: React.ReactNode, subtitle?: React.ReactNode }} props
 */
export function StepIntro({ title, subtitle }) {
  return (
    <div className="tdw-step-intro">
      <h2 className="tdw-step-intro-title">{title}</h2>
      {subtitle && <p className="tdw-step-intro-subtitle">{subtitle}</p>}
    </div>
  );
}
